import { render, staticRenderFns, recyclableRender, components } from "./uni-number-box.vue?vue&type=template&id=dd94a2a8&scoped=true&"
var renderjs
import script from "./uni-number-box.vue?vue&type=script&lang=js&"
export * from "./uni-number-box.vue?vue&type=script&lang=js&"
import style0 from "./uni-number-box.vue?vue&type=style&index=0&id=dd94a2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd94a2a8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-number-box/components/uni-number-box/uni-number-box.vue"
export default component.exports